/**
 * Maps English category names (from the scoring engine) to scoring.json translation keys.
 * Used with the hook-based t() function from useTranslation('scoring').
 */
const categoryKeyMap = {
  'Very Low': 'tScoreCategories.VL',
  'Moderately Low': 'tScoreCategories.ML',
  'Average': 'tScoreCategories.A',
  'Moderately High': 'tScoreCategories.MH',
  'Very High': 'tScoreCategories.VH',
  'Below Average': 'dciCategories.belowAverage',
  'Normal': 'dciCategories.normal',
  'Above Average': 'dciCategories.aboveAverage',
  'Extremely Low': 'msCategories.extremelyLow',
  'Low': 'msCategories.low',
  'Moderate': 'msCategories.moderate',
  'High': 'msCategories.high',
  'Extremely High': 'msCategories.extremelyHigh',
}

export default categoryKeyMap
